import { About } from "../../components/about"
import { Contact } from "../../components/contact"
import { Features } from "../../components/features"
import { Education } from "../../components/Education"
import { Header } from "../../components/header"
import { Navigation } from "../../components/navigation"
import { PsychologyServices } from "../../components/PsychologyServices"
import { Project } from "../../components/Project"
import { Production } from "../../components/Production"

export const Home = () => {
    return(
        <div>
            <Navigation />
            <Header />
            <Features />
            <About/>
            <PsychologyServices/>
            <Education  />
            <Production />
            <Project />
            <Contact />
        </div>
    )
}